export default __webpack_public_path__ + "static/media/community.6d76b9ba.jpg";